import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useMemo } from "react";

const useStyles = makeStyles({
  root: {
    border: 0,
    color: 'text.primary',
    height: 'auto',
    width: '100%',
    overflow: 'hidden'
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  }
});

export const EconomicsNI51101Table3Table = ({ economics }) => {

  // STYLES
  const classes = useStyles();
  const currency = economics?.settings?.currency;

  const rows = useMemo(() => {
    try {
      const data = [];

      data.push({
        id: 'Total Proved + Probable',
        revenue: Number((economics?.cashflowNet?.reduce((tot, curr) => tot + curr.grossRevenue, 0) / 1000)?.toFixed(2)),
        royalty: Number((economics?.cashflowNet?.reduce((tot, curr) => tot + curr.royalty, 0) / 1000)?.toFixed(2)),
        opex: Number((economics?.cashflowNet?.reduce((tot, curr) => tot + curr.costs, 0) / 1000)?.toFixed(2)),
        capex: Number((economics?.cashflowNet?.reduce((tot, curr) => tot + curr.capex, 0) / 1000)?.toFixed(2)),
        abandonment: Number((economics?.cashflowNet?.reduce((tot, curr) => tot + curr.abandonment, 0) / 1000)?.toFixed(2)),
        cashflowBTax: Number((economics?.cashflowNet?.[economics?.cashflowNet?.length - 1]?.cumCashflowBTax / 1000)?.toFixed(2)),
        incomeTax: Number((economics?.cashflowNet?.reduce((tot, curr) => tot + curr.incomeTax, 0) / 1000)?.toFixed(2)),
        cashflowATax: Number((economics?.cashflowNet?.[economics?.cashflowNet?.length - 1]?.cumCashflowATax / 1000)?.toFixed(2))
      });

      return data;

    } catch (error) {
    };
  }, [economics]);

  const columns = useMemo(() => {
    return [
      {
        field: 'id',
        headerName: 'Category',
        width: 200,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'revenue',
        headerName: `Revenue (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'royalty',
        headerName: `Royalties (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'opex',
        headerName: `Operating Costs (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'capex',
        headerName: `Development Costs (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'abandonment',
        headerName: `Aband. & Recl. Costs (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'cashflowBTax',
        headerName: `Future Net Rev. b/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'incomeTax',
        headerName: `Income Taxes (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'cashflowATax',
        headerName: `Future Net Rev. a/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      }
      
    ];
  }, [currency]);

  try {

    if (rows) {
      return (
        <div className={classes.root}>
          <DataGrid
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[10,25,50,100]}
            disableSelectionOnClick
            className={classes.table}
            components={{
              Toolbar: GridToolbar,
            }}
            sx={{fontSize: 12}}
            rowHeight={24}
            autoHeight={true}
          />
        </div>
      );
    } else {
      return <></>;
    };

  } catch (error) {
    return <></>
  };

};
